export enum ERequestTypes {
	DELETE = 'DELETE',
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT'
}

export type TRequestTypes = ERequestTypes.DELETE | ERequestTypes.GET | ERequestTypes.POST | ERequestTypes.PUT;

export enum ERequestCategory {
	token = 'token',
	fcnRequest = 'fcnRequest'
}

export type TRequestCategory = ERequestCategory.token | ERequestCategory.fcnRequest;
